// This file was automatically generated from appchart.dialog.eligibilities.html.
// Please don't edit this file by hand.

goog.provide('el8.template.appchart.dialog.eligibilities');

goog.require('soy');
goog.require('soy.StringBuilder');
goog.require('el8.template.appshared.form.eligibility');


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appchart.dialog.eligibilities.content = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  if (opt_data.eligibilities.length) {
    output.append('<ul class="ordersetContainer noAction">');
    var eligibilityList1510 = opt_data.eligibilities;
    var eligibilityListLen1510 = eligibilityList1510.length;
    for (var eligibilityIndex1510 = 0; eligibilityIndex1510 < eligibilityListLen1510; eligibilityIndex1510++) {
      var eligibilityData1510 = eligibilityList1510[eligibilityIndex1510];
      el8.template.appchart.dialog.eligibilities.eligibility(eligibilityData1510, output);
    }
    output.append('</ul>');
  } else {
    output.append('<div class="ordersetContainer">');
    el8.template.appshared.form.eligibility.content(opt_data, output);
    output.append('</div>');
  }
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appchart.dialog.eligibilities.eligibility = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<li class="item"><div class="ordersetTitle">', (opt_data.pbmName) ? '<span class="frame elt">PBM:</span><span class="elt">' + soy.$$escapeHtml(opt_data.pbmName) + '</span>' : '', (opt_data.error) ? '<span class="alert elt">ERROR</span>' : '', (opt_data.createDate) ? '<span class="system elt">(as of ' + (soy.$$escapeHtml(opt_data.createDate)? el8.service.tz.soyDate(soy.$$escapeHtml(opt_data.createDate)) : '') + ')</span>' : '', '</div><div class="ordersetDetails">', (opt_data.planName) ? '<p class="itemNoTextSaved"><span class="frame">Plan Name:</span> ' + soy.$$escapeHtml(opt_data.planName) + ' (' + soy.$$escapeHtml(opt_data.planStatus) + ')</p>' : '', (opt_data.planPcn) ? '<p class="itemNoTextSaved"><span class="frame">Plan PCN:</span> ' + soy.$$escapeHtml(opt_data.planPcn) + '</p>' : '');
  if (opt_data.error) {
    output.append('<p class="itemNoTextSaved alert"><span class="frame">Message:</span> ', soy.$$escapeHtml(opt_data.error), '</p>');
  } else {
    var coverageList1553 = opt_data.coverages;
    var coverageListLen1553 = coverageList1553.length;
    for (var coverageIndex1553 = 0; coverageIndex1553 < coverageListLen1553; coverageIndex1553++) {
      var coverageData1553 = coverageList1553[coverageIndex1553];
      output.append('<p class="itemNoTextSaved"><span class="frame elt">', (coverageData1553.planName) ? soy.$$escapeHtml(coverageData1553.planName) : '', ' ', soy.$$escapeHtml(coverageData1553.serviceType), ': </span><span class="elt">', soy.$$escapeHtml(coverageData1553.status), '</span></p>');
    }
  }
  output.append((opt_data.hasUpdates) ? '<p class="itemNoTextSaved"><div class="alertCaution">ALERT: This PBM has indicated it has patient demographic information that is <span class="emphasis">different</span> from what we have on file.</div></p>' : '', (opt_data.eligPatient) ? (opt_data.eligPatient.full_name) ? '<p class="itemNoTextSaved"><span class="frame">Patient Name:</span> ' + soy.$$escapeHtml(opt_data.eligPatient.full_name) + ', (DOB: ' + soy.$$escapeHtml(opt_data.eligPatient.dob) + ', Sex: ' + soy.$$escapeHtml(opt_data.eligPatient.sex) + ')</p><p class="itemNoTextSaved"><span class="frame">Patient Address:</span> ' + soy.$$escapeHtml(opt_data.eligPatient.full_address) + '</p>' : '<p class="itemNoTextSaved"><span class="frame">Patient Information not available</span></p>' : '', '</div></li>');
  if (!opt_sb) return output.toString();
};
